module.exports = __webpack_public_path__ + "static/the-guest-book-cc7bd51468247e5f5d3881ad922b6b54.jpg";